import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

//全局样式、字体和重置样式
import "@/assets/style/normalize.css";
import "@/assets/style/base.scss";
import "@/assets/iconfont/iconfont.css";
//饿了么库
import { Drawer, Tooltip, MessageBox, Link, Upload, Dialog, Input, Breadcrumb, BreadcrumbItem, Form, FormItem, RadioGroup, RadioButton, Button, Message, Notification, Select, Option, Tabs, TabPane, Row, Col, Radio, DatePicker, Image, Table, TableColumn, Pagination, Loading, Card } from "element-ui";
// import {Input} from 'element-ui'

import "@/assets/style/element-variables.scss";
import "element-ui/lib/theme-chalk/display.css";

// import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Drawer);
Vue.use(Tooltip);
Vue.use(Input);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Row);
Vue.use(Col);
Vue.use(Radio);
Vue.use(DatePicker);
Vue.use(Image);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(Upload);
Vue.use(Link);
Vue.use(Card);

Vue.use(Loading.directive);

Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;

import { transformError } from "@/utils/tools";
Vue.prototype.$transformError = transformError;

if (process.env.NODE_ENV !== "development") {
  let _hmt = _hmt || [];
  window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
  (function() {
    let hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?b11d61857ddbc0ae7e199bcf3b875274";
    let s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}

Vue.config.productionTip = false;

import "./permission"; // permission control
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// 设置浏览器标题
Vue.directive("title", {
  inserted: function(el, binding) {
    document.title = el.dataset.title;
  },
});
